module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('seo-title', {
    attrs: {
      "content": _vm.$t('contact.meta.title')
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": _vm.$t('contact.meta.description')
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": _vm.$t('contact.meta.title')
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": _vm.$t('contact.meta.description')
    }
  }), _vm._v(" "), _c('seo-og-image', {
    attrs: {
      "content": "/static/images/opengraph/fb_og.png"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "cph-bg top-panel"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h1', {
    staticClass: "test"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('contact.pageHeader')) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "fix-width"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('contact.pageSubheader')) + "\n            ")]), _vm._v(" "), _c('br'), _c('br')])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-light"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [(!_vm.submitted) ? _c('div', {
    staticClass: "contactform"
  }, [_c('h3', {
    staticClass: "contact-header"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('contact.contactformHeader')) + "\n                        ")]), _vm._v(" "), _c('form', {
    attrs: {
      "netlify": "",
      "netlify-honeypot": "bot-field",
      "name": "contact"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('contact.contactformName'),
      "name": "name"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('contact.contactformEmail'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('contact.contactformPhone'),
      "name": "phone"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.message),
      expression: "form.message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "8",
      "type": "text",
      "placeholder": _vm.$t('contact.contactformMessage'),
      "name": "message"
    },
    domProps: {
      "value": (_vm.form.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "message", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('button', {
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.isValidated
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleSubmit($event)
      }
    }
  }, [(_vm.isValidated) ? _c('span', [_vm._v("Send")]) : _c('span', [_vm._v(_vm._s(_vm.$t('contact.fillToSend')))])])])])])]) : _c('div', {
    staticClass: "contactform"
  }, [(_vm.submitSuccess) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('contact.formSuccessHeader')))]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(_vm.$t('contact.formSuccessText')) + "\n                            ")])]) : _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('contact.formErrorHeader')))]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(_vm.$t('contact.formErrorText')) + "\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('div', {
    staticClass: "cta-wrapper"
  }, [_c('div', {
    staticClass: "contact-cta"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tiny"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('contact.phoneHours')) + "\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [_c('h3', [_c('a', {
    staticClass: "emaillink",
    attrs: {
      "href": "mailto:kontakt@deveo.dk"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t('contact.emailText')) + "\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "tiny"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('contact.emailHours')) + "\n                                ")])])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('span', {
    staticClass: "ion-android-phone-portrait"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('a', {
    staticClass: "emaillink",
    attrs: {
      "href": "tel:+4571992895"
    }
  }, [_vm._v("\n                                        +45 71 99 28 95\n                                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('span', {
    staticClass: "ion-paper-airplane"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14c3fcde"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/contact/pages/index.vue
// module id = 304
// module chunks = 1